import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import {
  Table,
  TableBody,
  TableHeader,
  TableCell,
  DataTableCell,
} from '@david.kucsai/react-pdf-table';
import PropTypes from 'prop-types';
import moment from 'moment';

import logoNSA from '../../img/Logotipo_NSA.png';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    paddingTop: 25,
    paddingHorizontal: 32,
    paddingBottom: 20,
    fontSize: 8,
    fontFamily: 'Helvetica',
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },

  headerLeft: {
    width: '20%',
    textAlign: 'left',
    fontSize: 19,
    fontWeight: 'bold',
    color: '#000000',
  },

  headerCenter: {
    width: '60%',
    textAlign: 'center',
    fontSize: 12,
    color: '#000000',
  },

  headerRight: {
    width: '20%',
    textAlign: 'right',
    fontSize: 11,
    color: '#000000',
    marginRight: 55,
    marginLeft: -10,
  },

  headerLine: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    marginBottom: 16,
  },

  logo: {
    width: '33.33%',
    height: 30,
    objectFit: 'contain',
    marginLeft: -60,
  },

  osNumber: {
    fontSize: 19,
    fontWeight: 'bold',
    color: '#000000',
    letterSpacing: 0.8,
  },

  box: {
    border: '1 solid #ccc',
    padding: 7,
    marginBottom: 5,
  },

  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 1,
  },
  col: {
    width: '48%',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },

  label: {
    fontSize: 9,
    fontWeight: 'bold',
    marginRight: 4,
    marginBottom: 2,
    color: '#000000',
    letterSpacing: 0.6,
  },

  value: {
    fontSize: 9,
    fontWeight: 'normal',
    color: '#535353',
  },

  section: {
    width: '100%',
    flexDirection: 'column',
  },

  title: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: '#111111',
  },
  subtitle: {
    fontSize: 14,
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 8,
    color: '#000000',
    color: '#000000',
  },
  common: {
    color: '#333',
    fontSize: 16,
    fontWeight: 'normal',
  },
  tablecontainer: {
    marginTop: 16,
    marginBottom: 16,
  },
  tableheader: {
    paddingVertical: 6,
    paddingHorizontal: 8,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#000000',
    letterSpacing: 0.5,
  },
  tablecell: {
    paddingVertical: 6,
    paddingHorizontal: 8,
    fontSize: 8,
    color: '#535353',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },

});

export function MaintenancePDF({ maintenance }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>

          <View fixed>
            <View style={styles.header}>
              <Image style={styles.logo} src={logoNSA} />
              <Text style={styles.headerCenter}>Nº {maintenance.number}</Text>
              <Text fixed style={styles.headerRight} render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`} />
            </View>

            <View style={styles.headerLine} />
          </View>

          <View style={styles.box}>
            <View style={styles.row}>
              <View style={styles.col}>
                <Text style={styles.label}>TIPO:</Text>
                <Text style={styles.value}>{maintenance.type}</Text>
              </View>
              <View style={styles.col}>
                <Text style={styles.label}>EQUIPAMENTO:</Text>
                <Text style={styles.value}>{maintenance.equipment.code}</Text>
              </View>
            </View>
            <View style={styles.row}>
              <View style={styles.col}>
                <Text style={styles.label}>ABERTURA:</Text>
                <Text style={styles.value}>
                  {moment.utc(maintenance.opening_date).format('DD/MM/YYYY HH:mm')}
                </Text>
              </View>
              <View style={styles.col}>
                <Text style={styles.label}>FECHAMENTO:</Text>
                <Text style={styles.value}>
                  {maintenance.closing_date
                    ? moment(maintenance.closing_date).format('DD/MM/YYYY HH:mm')
                    : ''}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.box}>
            <Text style={styles.label}>DESCRIÇÃO DE ABERTURA:</Text>
            <Text style={styles.value}>{maintenance.opening_description || ''}</Text>
          </View>

          <View style={styles.box}>
            <Text style={styles.label}>OBSERVAÇÃO:</Text>
            <Text style={styles.value}>{maintenance.observation || ''}</Text>
          </View>

          <View style={styles.box}>
            <Text style={styles.label}>DESCRIÇÃO DE FECHAMENTO:</Text>
            <Text style={styles.value}>{maintenance.closing_description || ''}</Text>
          </View>

          {maintenance.maintenancepieces && maintenance.maintenancepieces.length > 0 && (
            <View style={{ marginTop: 8 }} >
              <Text style={styles.title}>SERVIÇOS E PEÇAS DA OS</Text>
              <Table data={maintenance.maintenancepieces}>
                <TableHeader textAlign="center" repeat>
                  <TableCell><Text style={styles.tableheader}>SERVIÇO/PEÇA</Text></TableCell>
                  <TableCell><Text style={styles.tableheader}>QUANTIDADE</Text></TableCell>
                  <TableCell><Text style={styles.tableheader}>VALOR</Text></TableCell>
                  <TableCell><Text style={styles.tableheader}>TOTAL</Text></TableCell>
                </TableHeader>
                <TableBody textAlign="center" wrap>
                  <DataTableCell
                    style={styles.tablecell}
                    getContent={r => r.piece ? r.piece.description : ''}
                  />
                  <DataTableCell
                    style={styles.tablecell}
                    getContent={r => (r.quantity !== 0 ? r.quantity : '')}
                  />
                  <DataTableCell
                    style={styles.tablecell}
                    getContent={r => (r.value !== 0 ? r.value : '')}
                  />
                  <DataTableCell
                    style={styles.tablecell}
                    getContent={r =>
                      r.value && r.quantity ? r.value * r.quantity : ''
                    }
                  />
                </TableBody>
              </Table>
            </View>
          )}

          {maintenance.maintenanceemployees && maintenance.maintenanceemployees.length > 0 && (
            <View style={{ marginTop: 8 }}>
              <Text style={styles.title}>FUNCIONÁRIOS DA OS</Text>
              <Table data={maintenance.maintenanceemployees}>
                <TableHeader textAlign="center" repeat>
                  <TableCell style={[styles.tableheader, { width: '45%' }]}>FUNCIONÁRIO</TableCell>
                  <TableCell style={[styles.tableheader, { width: '15%' }]}>INÍCIO</TableCell>
                  <TableCell style={[styles.tableheader, { width: '15%' }]}>FIM</TableCell>
                  <TableCell style={[styles.tableheader, { width: '25%' }]}>VISTO</TableCell>
                </TableHeader>
                <TableBody textAlign="center" wrap>
                  <DataTableCell
                    style={[styles.tablecell, { width: '55%' }]}
                    getContent={r => r.employee.name}
                  />

                  <DataTableCell
                    style={[styles.tablecell, { width: '10%' }]}
                    getContent={r => r.start || ''}
                  />

                  <DataTableCell
                    style={[styles.tablecell, { width: '10%' }]}
                    getContent={r => r.end || ''}
                  />

                  <DataTableCell
                    style={[styles.tablecell, { width: '25%' }]}
                    getContent= {r=>''}
                  />
                </TableBody>
              </Table>
            </View>
          )}
          <View style={{ marginTop: 10 }}>

            {/* DATA */}
            <View style={{ marginBottom: 10, alignItems: 'flex-start' }}>
              <View style={{ flexDirection: 'row'}}>
                <Text style={styles.label}>
                  DATA:
                </Text>

                <Text style={{ marginLeft: 10, color: '#000', fontWeight: 'extrabold' }}>
                  ____/____/_______
                </Text>
              </View>
            </View>

            {/* VISTO RESPONSÁVEL */}
            <View>
              <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
                <Text style={styles.label}>
                  VISTO RESPONSÁVEL:
                </Text>

                <View
                  style={{
                    flex: 1,
                    borderBottomWidth: 0.6,
                    //borderBottomColor: '#000',
                    marginLeft: 10,
                    marginBottom: 2
                  }}
                />
              </View>
            </View>

          </View>
        </View>
      </Page>
    </Document>
  );
}


export function OilChangePDF({ oilChangeEquipments }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.label}>
            <Text style={styles.title}>NSA - TROCA DE ÓLEO</Text>
          </View>

          <Table data={oilChangeEquipments}>
            <TableHeader textAlign="center">
              <TableCell style={styles.tableheader}>EQUIPAMENTO</TableCell>
              {/* <TableCell style={styles.tableheader}>KM ANTERIOR</TableCell>
              <TableCell style={styles.tableheader}>KM ATUAL</TableCell> */}
              <TableCell style={styles.tableheader}>TROCA DE ÓLEO</TableCell>
              <TableCell style={styles.tableheader}>ÚLTIMA LUBRIFICAÇÃO</TableCell>
              <TableCell style={styles.tableheader}>TIPO DA ÚLTIMA REVISÃO</TableCell>

            </TableHeader>
            <TableBody textAlign="center">
              <DataTableCell
                style={styles.tablecell}
                getContent={r => r.code}
              />
              {/* <DataTableCell
                style={styles.tablecell}
                getContent={r => r.maintenances[0] ? r.maintenances[0].km : '-'}
              />
              <DataTableCell
                style={styles.tablecell}
                getContent={r => r.odometers[0] ? r.odometers[0].km : '-'}
              /> */}
              <DataTableCell
                style={styles.tablecell}
                getContent={r => r.km_diff != null ? r.km_diff : '-'}
              />
              <DataTableCell
                style={styles.tablecell}
                getContent={r =>
                  r.last_lubrification_date
                    ? r.last_lubrification_date.substring(0, 10)
                        .split('-').reverse().join('/')
                    : '-'
                }
              />
              <DataTableCell
                style={styles.tablecell}
                getContent={r =>
                  r.maintenances && r.maintenances[0]
                    ? r.maintenances[0].type
                    : '-'
                }
              />
            </TableBody>
          </Table>
        </View>
      </Page>
    </Document>
  );
}

export function CalibrationPDF({ calibrationEquipments }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.label}>
            <Text style={styles.title}>NSA - CALIBRAGENS</Text>
          </View>
          <Table data={calibrationEquipments}>
            <TableHeader textAlign="center">
              <TableCell style={styles.tableheader}>EQUIPAMENTO</TableCell>
              <TableCell style={styles.tableheader}>ULTIMA CALIBRAGEM</TableCell>
            </TableHeader>
            <TableBody textAlign="center">
              <DataTableCell
                style={styles.tablecell}
                getContent={r => r.code}
              />
              <DataTableCell
                style={styles.tablecell}
                getContent={r => r.calibrations[0] ? moment(new Date(r.calibrations[0].createdAt)).format('DD/MM/YYYY') : '-'}
              />
            </TableBody>
          </Table>
        </View>
      </Page>
    </Document>
  );
}

MaintenancePDF.propTypes = {
  maintenance: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    number: PropTypes.number,
    opening_date: PropTypes.string,
    opening_description: PropTypes.string,
    closing_date: PropTypes.string,
    closing_description: PropTypes.string,
    observation: PropTypes.string,
    status: PropTypes.string,
    equipment: PropTypes.shape({
      code: PropTypes.string,
    }),
    maintenancepieces: PropTypes.shape({
      uuid: PropTypes.string,
    }),
    maintenanceemployees: PropTypes.shape({
      uuid: PropTypes.string,
    }),
  }),
};

MaintenancePDF.defaultProps = {
  maintenance: null,
};

OilChangePDF.propTypes = {
  oilChangeEquipments: PropTypes.arrayOf(
    PropTypes.shape({
      maintenances: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          uuid: PropTypes.string,
          number: PropTypes.number,
          opening_date: PropTypes.string,
          opening_description: PropTypes.string,
          closing_date: PropTypes.string,
          closing_description: PropTypes.string,
          observation: PropTypes.string,
          status: PropTypes.string,
          equipment: PropTypes.shape({
            code: PropTypes.string,
          }),
          maintenancepieces: PropTypes.shape({
            uuid: PropTypes.string,
          }),
          maintenanceemployees: PropTypes.shape({
            uuid: PropTypes.string,
          }),
        })
      ),
    })
  ),
};

OilChangePDF.defaultProps = {
  oilChangeEquipments: [],
};

CalibrationPDF.propTypes = {
  calibrationEquipments: PropTypes.arrayOf(
    PropTypes.shape({
      calibrations: PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string,
          equipment: PropTypes.shape({
            code: PropTypes.string,
          }),
        })
      ),
    })
  ),
};

CalibrationPDF.defaultProps = {
  calibrationEquipments: [],
};
